import { useContext, useState } from "react";
import { AppContext } from "../App";
import { AllergenIcon } from "./Allergens";
import { ALLERGEN_PRINT_NAMES, DIETS, emptyFilter } from "../utils/allergenFilter";

// Filtro allergeni e diete (YELLGO-6213): vale per i prodotti aggiunti da ora fino a Invia o Nuovo ordine
function AllergenFilterPopup() {
    const { allergenFilter, setAllergenFilter, setPopup } = useContext(AppContext);
    const [draft, setDraft] = useState({
        allergens: [...allergenFilter.allergens],
        diets: [...allergenFilter.diets],
    });

    const toggle = (key, value) => {
        const list = draft[key].includes(value) ? draft[key].filter((v) => v !== value) : [...draft[key], value];
        setDraft({ ...draft, [key]: list });
    };

    return (
        <>
            <div className="inner-content">
                <div className="allergen-filter-popup">
                    <div className="allergen-filter-label">Allergeni da evitare</div>
                    <div className="allergen-filter-grid">
                        {Object.entries(ALLERGEN_PRINT_NAMES).map(([id, name]) => {
                            const active = draft.allergens.includes(Number(id));
                            return (
                                <button
                                    key={id}
                                    type="button"
                                    className={"allergen-filter-option" + (active ? " active" : "")}
                                    aria-pressed={active}
                                    onClick={() => toggle("allergens", Number(id))}
                                >
                                    <AllergenIcon allergen={{ id: Number(id), name }} color={active ? "#fff" : "#36515c"} />
                                    <span>{name}</span>
                                </button>
                            );
                        })}
                    </div>
                    <div className="allergen-filter-label">Dieta</div>
                    <div className="allergen-filter-grid">
                        {DIETS.map((diet) => {
                            const active = draft.diets.includes(diet.id);
                            return (
                                <button
                                    key={diet.id}
                                    type="button"
                                    className={"allergen-filter-option diet" + (active ? " active" : "")}
                                    aria-pressed={active}
                                    onClick={() => toggle("diets", diet.id)}
                                >
                                    <span>{diet.label}</span>
                                </button>
                            );
                        })}
                    </div>
                    <div className="allergen-filter-hint">
                        Vale per i prodotti che aggiungi da ora fino a Invia o Nuovo ordine. Si basa sugli allergeni
                        inseriti nel catalogo: un prodotto senza allergeni segnati risulta adatto. La dieta vegana
                        richiede che i prodotti siano marcati vegani.
                    </div>
                </div>
            </div>
            <div className="allergen-filter-buttons">
                <button type="button" className="secondary" onClick={() => setDraft(emptyFilter())}>
                    Svuota
                </button>
                <button
                    type="button"
                    className="primary"
                    onClick={() => {
                        setAllergenFilter(draft);
                        setPopup(false);
                    }}
                >
                    Applica
                </button>
            </div>
        </>
    );
}

export default AllergenFilterPopup;
